import { NotificationManager } from "react-notifications";

export function notifications(data) {
    switch (data.type) {
      case "info":
        NotificationManager.info(data.mess, "", 1000);
        break;
      case "success":
        NotificationManager.success(data.mess, "Thành công", 3000);
        break;
      case "warning":
        NotificationManager.warning(data.mess, "Cảnh báo", 3000);
        break;
      case "customer":
        NotificationManager.success(data.mess, "Khách hàng đến store", 3000);
        break;
      case "error":
        NotificationManager.error(data.mess, "Lỗi", 3000);
        break;

      case "rating5":
        NotificationManager.success(data.mess, "5 Sao", 3000);
        break;

      case "rating4":
        NotificationManager.info(data.mess, "4 Sao", 3000);
        break;

      case "rating3":
        NotificationManager.warning(data.mess, "3 Sao", 3000);
        break;

      case "rating2":
        NotificationManager.error(data.mess, "2 Sao", 3000);
        break;

      case "rating1":
        NotificationManager.error(data.mess, "1 Sao", 3000);
        break;

      case "qrcode":
          NotificationManager.error(data.mess, data.title, 3000);
          break;  
    }
}
